/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Učitavanje...',
	'dlg_close': 'Zatvori',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Opoziv',
	'dlg_back': 'Idi natrag',
	'dlg_done': 'Gotovo',
	'dlg_save': 'Spremi',

	// Slider
	'sliderRegionLabel': 'Kontrola s klizačem, koristite strelice desno i lijevo za pomicanje držača klizača',
	'sliderHandleLabel': 'Držač klizača',
	'a11ySliderHandleLabel': 'Držač klizača %{sliderValue}',
	'sliderInputLabel': 'vrijednost',

	// Side bar
	'sidebarAdd': 'Dodaj',
	'clearTextFilterValue': 'Isprazni',
	'missingDataSetData': 'Podaci ovog skupa podataka nisu dostupni. Osvježite skup podataka ili kontaktirajte svog administratora u vezi pristupa izvoru podataka.',

	// Toolbar
	'toolbarRegionLabel': 'Traka s alatima',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Obitelj fontova',
	'fontFamilyStyle': 'Stil fonta',
	'regularFontStyle': 'Redovni',
	'fontSizeSelect': 'Veličina fonta',
	'fontColorSelect': 'Boja',
	'fontStyle': 'Stil',
	'colorPickerTitle': 'Biranje boje',
	'bold': 'Podebljano',
	'italic': 'Kurziv',
	'underline': 'Podcrtano',
	'fontAlignment': 'Poravnanje',
	'justifyLeft': 'Poravnaj lijevo',
	'justifyCenter': 'Poravnaj u sredini',
	'justifyRight': 'Poravnaj desno',
	'insertOrderedList': 'Poredana lista',
	'insertUnorderedList': 'Neporedana lista',
	'fontColorPicker': 'Izbornik boja',
	'textWrap': 'Omotaj tekst',
	'restore': 'Vrati defaulte',
	'textAutoFontSize': 'Automatski',
	'textDefaultFontSize': 'Zadano',
	'textItemTitle': 'Naslov',
	'textLabelShadow': 'Sjena oznake',
	'textContrastLabelColor':'Boja kontrasta',
	'toggleOn': 'Uključi',
	'toggleOff': 'Isključi',
	'contrastLabelColorInfo': 'Automatski podesi boju oznake za pristupačnost. Ovo nadjačava boju fonta.',
	'labelShadowInfo':'Dodajte sjenu na tekst za pristupačnost.',
	'applyToAll':'Primijeni stiliziranje na sve osi',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Broj rezultata (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Postotak (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Opcija vrha ili dna',
	'topbottomOptionLabel': 'Pokaži',
	'searchByLabel': 'Po',
	'searchNoMatches': 'Nisu nađena podudaranja',
	'topbottomRankColumnLabel': 'Dodaj tablici stupac ranga',
	'topbottomNone': 'Nijedan',
	'topCount': 'Brojač gornjih',
	'topPercent': 'Gornjih %',
	'bottomCount': 'Brojač donjih',
	'bottomPercent': 'Donjih %',
	'searchColumn': 'Pronađi stupac',
	'searchColumnAriaLabel': 'Pronađite stupac. Upišite naziv stupca kojeg tražite, zatim koristite strelicu dolje da pronađete stupac na listi',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Resetiraj',

	// Format
	'formatAuto': 'Automatski',
	'formatConvertPercent': 'Konvertiraj decimalno u postotak',
	'formatAbbreviate': 'Skrati',
	'formatUseGrouping': 'Koristi odjelitelj tisućica',
	'dateStyle': 'Stil datuma',
	'dateTimeStyle': 'Stil datuma/vremena',
	'formatMissingValueCharactersInfo': 'Karakteristike vrijednosti koje nedostaju specificiraju znakove koji se prikazuju kad vrijednost nedostaje.',
	'currencySymbolLabel': 'Znak valute',
	'customSymbolPlaceholder': 'Dodaj simbol',
	'customSymbolLabelInfo': 'Specificira znak ili znakove koji se koriste kao prilagođeni simbol. Ovaj simbol će prethoditi broju i bilo kojem znaku.',
	'numberLabel': 'Oznaka broja',
	'numberPositionLabel': 'Pozicija oznake',
	'negativeSignPosition': 'Položaj negativnog predznaka',
	'negativeSign': 'Simbol negativnog predznaka',
	'numberLabelInfo': 'Specificira oznaku za formatirani broj, koja se stavlja kao prefiks ili sufiks ovisno o poziciji oznake.',
	'nullValueDefault': '<default>',
	'nullValueContent': '(nema vrijednost)',
	'default': 'Default',
	'beginning': 'Početak',
	'end': 'Kraj',
	'formatLabel': 'Izaberite format',

	// More data indicator
	'moreDataIndicator': 'Vaši podaci su odrezani nakon %{threshold} stavki. Primijenite filter ako želite prikazati manje.',

	// Expanded View / Focus mode
	'evCollapse': 'Skupi',
	'duplicate': 'Dupliciraj',
	'copyOf': 'Kopija od %{name}',
	'unableToDuplicateBoard': 'Ne može se duplicirati "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Ne možemo učitati objekte.',

	// Custom widgets
	'customWidget': 'Prilagođeni grafički element',

	// Auto group
	'group': 'Grupa',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Vrlo tanko',
	'textFontFamilySubClassThin': 'Tanko',
	'textFontFamilySubClassThinItalic': 'Tanki kurziv',
	'textFontFamilySubClassExtraLight': 'Vrlo svjetlo',
	'textFontFamilySubClassExtraLightItalic': 'Vrlo svjetli kurziv',
	'textFontFamilySubClassLight': 'Svjetlo',
	'textFontFamilySubClassLightItalic': 'Svjetli kurziv',
	'textFontFamilySubClassRegular': 'Redovni',
	'textFontFamilySubClassRegularItalic': 'Redovni kurziv',
	'textFontFamilySubClassItalic': 'Kurziv',
	'textFontFamilySubClassMedium': 'Srednji',
	'textFontFamilySubClassMediumItalic': 'Srednji kurziv',
	'textFontFamilySubClassHeavy': 'Deblje',
	'textFontFamilySubClassHeavyItalic': 'Deblji kurziv',
	'textFontFamilySubClassDemiBold': 'Polu podebljano',
	'textFontFamilySubClassDemiBoldItalic': 'Polu podebljani kurziv',
	'textFontFamilySubClassBold': 'Podebljano',
	'textFontFamilySubClassBoldItalic': 'Podebljani kurziv',
	'textFontFamilySubClassExtraBold': 'Jako podebljano',
	'textFontFamilySubClassExtraBoldItalic': 'Jako podebljani kurziv',
	'textFontFamilySubClassBlack': 'Crna',
	'textFontFamilySubClassBlackItalic': 'Crni kurziv',
	'textFontFamilySubClassStencil': 'Matrica',
	// END: Remove FontFamilySubClass
});
